import React from 'react';
import Modal from 'react-modal';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import {NotificationManager} from "react-notifications";

import * as RaceActions from "../../../../actions/race"
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from '../../../reusable/UserFieldElement';
import config from "../../../../../../server/src/config";
import moment from "moment";
import {alert} from "../../../../utils/alertDialog";

class ImportMemberProgramDialog extends React.Component {

    static propTypes = {
        onClose: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            week: moment(new Date()).isoWeek().toString(),
            pigeonhole: 'all',
            reset: false,
            overwrite: false
        }
    }

    fields = [];
    render() {
        const isRaces = this.props.race.races.filter(race => race.Uge === Number(this.state.week)).size > 0;
        return <div>
            <Modal
                isOpen={true}
                onRequestClose={() => {
                    this.props.onClose()
                }}
                style={{
                    overlay: {
                        zIndex: 10,
                    },
                    content: {
                        height: '275px',
                        width: '450px',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }
                }}
            >
                <div className="dialog">
                    <div className="dialog-title">Læs anmeldelser fra medlemsprogram</div>

                    <div className="dialog-body">
                        <div className="dialog-inner-body">
                            <table className="fields">
                                <tbody>
                                <tr>
                                    <td><label htmlFor="week">Uge</label></td>
                                    <td>
                                        <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                          name="week" id="week" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "[0-9]{1,2}"}]} value={this.state.week}
                                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[0] = instance; }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="medium-vertical-spacing"><label htmlFor="pigeonhole">Slag</label></td>
                                    <td className="medium-vertical-spacing">
                                        <UserFieldElement dataType={UserFieldDataType.enum} placeholder={false} className="field100p" containerClassName="display-inline-block field100p"
                                                          name="pigeonhole" id="pigeonhole" value={this.state.pigeonhole} options={[{key: 'all', value: 'Alle'}].concat(
                                                              this.props.admin.pigeonHoles.filter(hole => hole.Foreningsnr === this.props.auth.currentEntity).sort((s1, s2) => s1.Slagnr < s2.Slagnr ? -1 : 1).map(pigeonhole => (
                                                                  {key: pigeonhole.Slagnr, value: pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? '' : ' - ' + pigeonhole.Slagnavn)}
                                                              )).toArray())}
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[1] = instance; }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="checkbox" name="reset" id="reset" checked={this.state.reset} onChange={this.onCheckFieldChange}/>
                                    </td>
                                    <td>
                                        <label htmlFor="reset">Nulstil alle anmeldelser</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="checkbox" name="overwrite" id="overwrite" disabled={this.state.reset} checked={this.state.overwrite} onChange={this.onCheckFieldChange}/>
                                    </td>
                                    <td>
                                        <label htmlFor="overwrite" className={this.state.reset ? 'disabled' : ''}>Flyt duer hvis anmeldt på andre flyvninger</label>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="actions-row">
                        <button className="btn-primary" name="send" disabled={!isRaces} onClick={() => {this.onSend()}}>Indlæs</button>
                        <button className="btn-secondary float-right" onClick={() => {this.props.onClose()}}>Annuller</button>
                    </div>
                </div>
            </Modal>
        </div>
    }

    onSend = () => {
        if (this.allInputValid()) {
            this.props.dispatch(RaceActions.getFromMember(this.props.auth.currentEntity, this.state.week, this.state.pigeonhole, this.state.reset, this.state.overwrite, (response) => {
                const msg = response.map((line, ix) => [line, <br/>]);
                alert("Info", msg, () => {}, {textAlign: "left"});
                this.props.onClose();
            }));
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    };

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onCheckFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.checked});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };
}

const mapStateToProps = (state) => ({
    auth: {
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        pigeonHoles: state.admin.pigeonHoles,
    },
    race: {
        races: state.race.races
    }
});

export default connect(mapStateToProps)(ImportMemberProgramDialog);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/home/dialogs/ImportMemberProgramDialog.js